import Grid from '@/global/components/ui/Grid'
import { hasPermission } from '@/hooks/useBackendMenu'
import { StatusAprovacao } from '@acme/core'
import dayjs from 'dayjs'
import {
    FormDatePicker,
    FormField,
    FormFieldSelect,
    FormFile,
} from 'global/components/Form'
import { SelectFuncionarios } from 'global/components/Selects'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { ocorrencia, ocorrenciaTipoToPermission } from 'service/api'
import { match } from 'ts-pattern'

export default function FormDetalhesAfastamento() {
    const { data: ocorrencias = [] } = ocorrencia.useFetch()
    const { watch, setValue } = useFormContext()

    const [dataInicial, dataFinal, dias, funcionarioId, statusAprovacao] =
        watch([
            'dataInicial',
            'dataFinal',
            'dias',
            'funcionarioId',
            'statusAprovacao',
        ])

    const isDiasFocado = document.activeElement?.id === 'field-dias'
    const isDataFocado = ['field-data-final', 'field-data-inicial'].includes(
        document.activeElement?.id ?? '',
    )

    useEffect(() => {
        if (isDiasFocado) {
            if (!dataInicial || dias < 1) return
            const dataFinal = dayjs(dataInicial)
                .add(dias - 1, 'day')
                .format('YYYY-MM-DD')
            setValue('dataFinal', dataFinal)
        }
        if (isDataFocado) {
            if (!dataInicial || dayjs(dataFinal).isBefore(dataInicial)) return
            setValue('dias', dayjs(dataFinal).diff(dataInicial, 'day') + 1)
        }
    }, [dataInicial, dataFinal, isDiasFocado, isDataFocado, setValue, dias])

    return (
        <Grid container className="items-center">
            <Grid item xs={12}>
                <SelectFuncionarios
                    variant="form"
                    defaultValues={[funcionarioId]}
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <FormFieldSelect
                    name="ocorrenciaId"
                    label="Ocorrência"
                    required
                    options={ocorrencias.map(
                        ({ codigo, id, descricao, tipo, disabled }) => ({
                            value: id,
                            label: `${String(codigo).padStart(
                                3,
                                '0',
                            )}: ${descricao}`,
                            disabled:
                                !hasPermission([
                                    'update',
                                    ocorrenciaTipoToPermission(tipo),
                                ]) || disabled,
                        }),
                    )}
                />
            </Grid>
            <Grid item xs={5}>
                <FormDatePicker
                    id="field-data-inicial"
                    name="dataInicial"
                    label="Data inicial"
                    type="date"
                    required
                />
            </Grid>
            <Grid item xs={5}>
                <FormDatePicker
                    required
                    id="field-data-final"
                    name="dataFinal"
                    label="Data final"
                    type="date"
                />
            </Grid>
            <Grid item xs={2}>
                <FormField
                    id="field-dias"
                    name="dias"
                    label="Dias"
                    type="number"
                    disabled={!dataInicial}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFile name="fileUrl" disabled />
            </Grid>
            {match(statusAprovacao)
                .with(StatusAprovacao.PENDENTE, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Motivo da inclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .with(StatusAprovacao.PENDENTE_EXCLUSAO, () => (
                    <Grid item xs={12}>
                        <FormField
                            name="MotivoExclusao.motivo"
                            label="Motivo da exclusão"
                            multiline
                            disabled
                        />
                    </Grid>
                ))
                .otherwise(() => (
                    <Grid item xs={12}>
                        <FormField
                            name="justificativa"
                            label="Justificativa"
                            multiline
                            disabled
                        />
                    </Grid>
                ))}
        </Grid>
    )
}
